module.exports = __webpack_public_path__ + "static/zohodevelopment-8aeec987674802119594501e12949133.png";